import {
  setValidateSubscription,
  setSubscriptionChecked,
  setHasUsedFreeTrial,
} from "./slices/userSlice";

export const validateSubscriptionAction =
  (apiInstance, role, userId) => async (dispatch) => {
    try {
      const normalizedRole = role?.toLowerCase?.();

      // High school coaches never hit the subscription endpoint, so the check
      // has to be marked as resolved explicitly. `hasSubscription` stays false
      // on purpose: access is granted by role in useSubscriptionAccess.
      if (normalizedRole === "highschool") {
        dispatch(setSubscriptionChecked());
        return;
      }

      if (normalizedRole === "admin") {
        dispatch(setValidateSubscription(true));
        return;
      }

      let url = "";
      if (normalizedRole === "athlete") url = `/athlete/profile/${userId}`;
      else if (normalizedRole === "university") url = `/coach/profile`;

      const res = await apiInstance.get(url);
      if (normalizedRole === "athlete") {
        dispatch(setHasUsedFreeTrial(!!res?.data?.hasUsedFreeTrial));
      }
      dispatch(setValidateSubscription(!!res?.data?.hasCurrentSubscription));
    } catch (e) {
      console.error(e);
      // setValidateSubscription also sets subscriptionChecked = true, so the
      // flag always resolves on failure and the upsell UI is never stuck hidden.
      dispatch(setValidateSubscription(false));
    }
  };
